// const BASE_URL: string = 'https://bd93-186-77-133-86.ngrok-free.app' + '/api';
// const BASE_URL: string = 'http://3.148.210.97' + '/api';
// const BASE_URL: string = 'http://10.211.55.5:5097' + '/api';
const BASE_URL: string = 'https://tsin.tsillc.com' + '/api';
const VERSION: string = 'v1';

export const catalogQueries = {
  // Search
  SHIPPER_QUERY: 'GetShippersQuery',
  CONSIGNEE_QUERY: 'GetConsigneesQuery',
  CUSTOMER_QUERY: 'GetCustomersQuery',
  RAMP_MASTER_QUERY: 'GetRampMasterQuery',
  LESSEE_QUERY: 'GetLesseeQuery',
  // GetAll
  ACCESORIAL_QUERY: 'GetAccesorialsQuery',
  BOXSIZE_QUERY: 'GetBoxSizeQuery',
  ORDER_TYPE_QUERY: 'GetOrderTypesQuery',
  ORDER_STATUS_QUERY: 'GetOrderStatusQuery',
  STATUS_TRIP_QUERY: 'GetStatusTripQuery',
};

export const endpoints = {
  // Login
  LOGIN: `${BASE_URL}/identity/${VERSION}/login`,

  // Catalogs
  GENERIC_CATALOG_SEARCH: `${BASE_URL}/read-catalogs/${VERSION}/get-by-search-param`,
  GENERIC_GET_ALL: `${BASE_URL}/read-catalogs/${VERSION}/get-all-catalogs`,
  SEARCH_DRIVER: `${BASE_URL}/read-catalogs/${VERSION}/drivers`,
  SEARCH_CITY: `${BASE_URL}/read-catalogs/${VERSION}/cities`,
  SEARCH_LESSEE: `${BASE_URL}/read-catalogs/${VERSION}/leasor`,
  SEARCH_CITY_RAMP_LOCATION: `${BASE_URL}/read-catalogs/${VERSION}/city-ramp-location`,

  // Driver Document Types
  DRIVER_DOCUMENT_TYPES: `${BASE_URL}/driver-document-types/${VERSION}`,
  DRIVER_DOCUMENT_TYPE_BY_ID: (id: number) => `${BASE_URL}/driver-document-types/${VERSION}/${id}`,

  // Driver Documents
  DRIVER_DOCUMENTS: `${BASE_URL}/driver-documents/${VERSION}`,
  DRIVER_DOCUMENT_BY_ID: (id: number) => `${BASE_URL}/driver-documents/${VERSION}/${id}`,
  DRIVER_DOCUMENTS_BY_DRIVER: (driverId: number) => `${BASE_URL}/driver-documents/${VERSION}/driver/${driverId}`,
  DRIVER_DOCUMENT_INVALIDATE: (id: number) => `${BASE_URL}/driver-documents/${VERSION}/${id}/invalidate`,

  // Orders
  SAVE_ORDER: `${BASE_URL}/orders/${VERSION}/add-order`,
  EDIT_ORDER: `${BASE_URL}/orders/${VERSION}/edit-order`,
  FILTER_ORDERS: `${BASE_URL}/orders/${VERSION}/filter-orders`,
  DRAY_CALCULATION: `${BASE_URL}/orders/${VERSION}/dray-calculation`,
  GET_SINGLE_ORDER: `${BASE_URL}/orders/${VERSION}/get-order-by`,
  SET_ORDER_INVOICED: `${BASE_URL}/orders/${VERSION}/set-invoiced`,
  SET_ORDERS_INVOICED: `${BASE_URL}/orders/${VERSION}/set-orders-invoiced`,
  SEND_EMAIL_TO_CUSTOMER  : `${BASE_URL}/orders/${VERSION}/sendEmail-invoice`,
  GET_CHARGES_RESUME: `${BASE_URL}/orders/${VERSION}/charges-resume`,
  UPLOAD_IMAGES: `${BASE_URL}/orders/${VERSION}/delivery-documents`,
  GET_IMAGES: `${BASE_URL}/orders/${VERSION}/images`,
  DELETE_IMAGES: `${BASE_URL}/orders/${VERSION}/delete-image`,
  DOWNLOAD_INVOICE: `${BASE_URL}/orders/${VERSION}/download-invoice`,
  TICKET_STOPS_CONSIGNEES: `${BASE_URL}/orders/${VERSION}/ticket-multistop-consigness`,

  // Multi-Stops
  GET_MULTI_STOPS: `${BASE_URL}/orders/${VERSION}/multiStops`,
  MUTATE_MULTI_STOPS: `${BASE_URL}/orders/${VERSION}/mutate-multistops`,
  DELETE_MULTI_STOPS: `${BASE_URL}/orders/${VERSION}/delete-multistops`,

  // Customer endpoints
  CUSTOMER_COMMAND: `${BASE_URL}/customers/${VERSION}`,
  CUSMTOMER_LIST: `${BASE_URL}/customers/${VERSION}/get-all`,
  SAVE_CUSTOMER: `${BASE_URL}/customers/${VERSION}`,
  DELETE_CUSTOMER: `${BASE_URL}/customers/${VERSION}/delete`,
  GET_CUSTOMERS_EMPLOYESS: `${BASE_URL}/customers/${VERSION}/employees`,
  SAVE_CUSTOMER_EMPLOYEE: `${BASE_URL}/identity/${VERSION}/register`,

  // Customer Portal
  GET_PORTAL_APPTS: `${BASE_URL}/customers/${VERSION}/portal-appts`,
  GET_PORTAL_HISTORY: `${BASE_URL}/customers/${VERSION}/portal-history`,

  // MultiStop endpoints
  GET_MULTISTOP_ORDERS: `${BASE_URL}/orders/${VERSION}/multistops`,

  // Accesorials
  PATCH_ACCESORIAL: `${BASE_URL}/Accesorials/${VERSION}`,
  DELETE_ACCESORIAL: `${BASE_URL}/Accesorials/${VERSION}/delete`,
  SAVE_ACCESORIALS: `${BASE_URL}/orders/${VERSION}/attach-accesorials`,
  ACCESORIAL_BELONGING: `${BASE_URL}/read-catalogs/${VERSION}/accessorials`,
  GET_ACCESORIALS_BY_PROID: `${BASE_URL}/orders/${VERSION}/accessorials`,
  DELETE_ORDER_ACCESORIAL: `${BASE_URL}/orders/${VERSION}/delete-accesorials`,
  DELETE_DRIVER_ACCESORIAL: `${BASE_URL}/driverAccessorials/${VERSION}`,

  // Appointment
  SAVE_APPOINTMENT: `${BASE_URL}/orders/${VERSION}/edit-order`,

  // Driver
  GET_DRIVERPAY_BY_PROID: `${BASE_URL}/driverPay/${VERSION}/by-order`,
  SAVE_DRIVERPAY: `${BASE_URL}/driverPay/${VERSION}`,
  GET_DRIVERPAY: `${BASE_URL}/driverPay/${VERSION}`,
  DELETE_DRIVERPAY: `${BASE_URL}/driverPay/${VERSION}`,
  GET_DRIVERACC_BY_SEQNUM: `${BASE_URL}/driverAccessorials/${VERSION}/by-driverSeqNum`,
  SAVE_DRIVERACC: `${BASE_URL}/drivers/${VERSION}/attach-accesorials`,
  GET_ALL_DRIVERS: `${BASE_URL}/read-catalogs/${VERSION}/drivers-master`,
  DELETE_DRIVER: `${BASE_URL}/drivers/${VERSION}`,
  PATCH_DRIVER: `${BASE_URL}/drivers/${VERSION}`,
  /** GET ?driverId= — usuarios de app no asignados a otro driver + el ya vinculado a este driver (si aplica). Requiere implementación en API. */
  DRIVER_AVAILABLE_APP_USERS: `${BASE_URL}/drivers/${VERSION}/available-app-users`,
  GET_DRIVER_PAY_REPORT: `${BASE_URL}/driverPay/${VERSION}/driver-pay-report`,

  // Shipper
  PATCH_SHIPPER: `${BASE_URL}/shippers/${VERSION}`,
  DELETE_SHIPPER: `${BASE_URL}/shippers/${VERSION}`,

  // Consignee
  PATCH_CONSIGNEE: `${BASE_URL}/consignees/${VERSION}`,
  DELETE_CONSIGNEE: `${BASE_URL}/consignees/${VERSION}`,

  // BoxSize
  SAVE_BOXSIZE: `${BASE_URL}/boxsizes/${VERSION}`,

  // Storage
  SEARCH_STORAGE: `${BASE_URL}/read-catalogs/${VERSION}/storageLocations`,
  STORAGE: `${BASE_URL}/storagesOrder/${VERSION}`,
  PATCH_STORAGE: `${BASE_URL}/storages/${VERSION}/locations`,

  // City
  PATCH_CITY: `${BASE_URL}/city/${VERSION}`,
  DELETE_CITY: `${BASE_URL}/city/${VERSION}`,
  PATCH_CITY_RATE_MILES: `${BASE_URL}/city/${VERSION}/city-rate-miles`,

  // Preference
  GET_PREFERENCES: `${BASE_URL}/parameters/${VERSION}`,

  //Payments
  CUSTOMERS_PAYMENT_CHECK: `${BASE_URL}/payments/${VERSION}/customers-check`,
  GET_PAYMENTS_STATS_COUNTER: `${BASE_URL}/payments/${VERSION}/stats-counter`,
  SET_PAYMENT: `${BASE_URL}/payments/${VERSION}/customers-check`,
  GET_ORDER_PAYMENTS: `${BASE_URL}/payments/${VERSION}/customers-payment-detail`,
  SET_ORDER_PAYMENTS: `${BASE_URL}/payments/${VERSION}/customers-payment-detail`,
  GET_VENDOR_PAYMENTS_PENDING: `${BASE_URL}/payments/${VERSION}/vendor-payment-documents`,
  GET_CUSTOMER_DOCUMENT_MOVEMENTS: `${BASE_URL}/payments/${VERSION}/customer-document-movements`,
  GET_CUSTOMER_BALANCE: `${BASE_URL}/payments/${VERSION}/customer-balance`,

  // RATES
  GET_RATES: `${BASE_URL}/read-catalogs/${VERSION}/rates`,
  PATCH_RATE: `${BASE_URL}/rates/${VERSION}`,
  DELETE_RATE: `${BASE_URL}/rates/${VERSION}`,
  CITY_RATE: `${BASE_URL}/city/${VERSION}/city-rates`,
  GET_CITY_RATES: `${BASE_URL}/read-catalogs/${VERSION}/city-rates`,
  SET_CITY_RATES: `${BASE_URL}/read-catalogs/${VERSION}/get-by-search-param`,
  SET_RATES: `${BASE_URL}/read-catalogs/${VERSION}/get-by-search-param`,

  // RAMPS
  RAMP: `${BASE_URL}/ramps/${VERSION}`,

  // TRACKING
  TRACKING: `${BASE_URL}/driverPay/${VERSION}/tracking`,

  // COMMUNICATION
  NOTIFY_DRIVER: `${BASE_URL}/communication/${VERSION}`,
  NOTIFY_PIER_APPT: `${BASE_URL}/communication/${VERSION}/update_pier_appt`,

  // PREFERENCES
  PREFERENCE: `${BASE_URL}/preferences/${VERSION}`,

  //ACCOUNTING
  GET_INVOICES_PENDING_POST: `${BASE_URL}/accounting/${VERSION}/invoices-pending`,
  GET_DRIVER_PAYEMENTS_PENDING_POST: `${BASE_URL}/accounting/${VERSION}/driverpay-pending`,
  SET_INVOICES_PENDING_TO_POST: `${BASE_URL}/accounting/${VERSION}/set-invoice-posted`,
  GET_CHECK_PENDING_TO_POST: `${BASE_URL}/accounting/${VERSION}/check-pending`,

  //Lessee
  GET_LESSEE: `${BASE_URL}/lessee/${VERSION}`,
  SET_LESSEE: `${BASE_URL}/lessee/${VERSION}`,
  PACTH_LESSEE: `${BASE_URL}/lessee/${VERSION}`,
  DELET_LESSEE: `${BASE_URL}/lesee/${VERSION}/`,

  //REPORTS
  GET_DRIVER_DAILY_LOG: `${BASE_URL}/orders/${VERSION}/driver-daily-log2`,
  GET_AGING_SUMMARY: `${BASE_URL}/orders/${VERSION}/aging-summary-report`,
  GET_AGING_SUMMARY_DATA: `${BASE_URL}/orders/${VERSION}/aging-summary-data`,
  GET_AGING_SUMMARY_DETAILED: `${BASE_URL}/orders/${VERSION}/aging-summary-report/detailed`,
  GET_MOVEMENT_DETAIL: `${BASE_URL}/reports/${VERSION}/movement-detail`,

  // ADMIN - Users Management
  GET_USERS: `${BASE_URL}/admin/users/${VERSION}`,
  GET_USER_BY_ID: `${BASE_URL}/admin/users/${VERSION}`,
  CREATE_USER: `${BASE_URL}/admin/users/${VERSION}`,
  UPDATE_USER: `${BASE_URL}/admin/users/${VERSION}`,
  DELETE_USER: `${BASE_URL}/admin/users/${VERSION}`,
  CHANGE_USER_PASSWORD: `${BASE_URL}/admin/users/${VERSION}`,
  LOCK_USER: `${BASE_URL}/admin/users/${VERSION}`,
  ASSIGN_USER_ROLES: `${BASE_URL}/admin/users/${VERSION}`,

  // ADMIN - Roles Management
  GET_ROLES: `${BASE_URL}/admin/roles/${VERSION}`,
  GET_ROLE_BY_ID: `${BASE_URL}/admin/roles/${VERSION}`,
  CREATE_ROLE: `${BASE_URL}/admin/roles/${VERSION}`,
  UPDATE_ROLE: `${BASE_URL}/admin/roles/${VERSION}`,
  DELETE_ROLE: `${BASE_URL}/admin/roles/${VERSION}`,

  // ADMIN - Permissions Management
  GET_AVAILABLE_PERMISSIONS: `${BASE_URL}/admin/roles/${VERSION}/permissions/available`,
  GET_ROLE_PERMISSIONS: `${BASE_URL}/admin/roles/${VERSION}`,  // /{roleId}/permissions
  UPDATE_ROLE_PERMISSIONS: `${BASE_URL}/admin/roles/${VERSION}`,  // /{roleId}/permissions
  ADD_ROLE_PERMISSION: `${BASE_URL}/admin/roles/${VERSION}`,  // /{roleId}/permissions/{permission}
  REMOVE_ROLE_PERMISSION: `${BASE_URL}/admin/roles/${VERSION}`,  // /{roleId}/permissions
  CHECK_ROLE_PERMISSION: `${BASE_URL}/admin/roles/${VERSION}`,  // /{roleId}/permissions/{permission}/check
};
